import { render, staticRenderFns } from "./realEstateFurniture.vue?vue&type=template&id=48772f27&"
import script from "./realEstateFurniture.vue?vue&type=script&lang=js&"
export * from "./realEstateFurniture.vue?vue&type=script&lang=js&"
import style0 from "./realEstateFurniture.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports